import React, { useEffect, useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { useTranslation } from "react-i18next";
import { arSD } from "@mui/material/locale";
import { themeOptions } from "../utils/theme";
import dayjs from "../utils/dayjs";

const cache = createCache({ key: "mui-ltr" });

const ThemeLocaleProvider = ({ children, uiTemplate = "classic" }) => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  useEffect(() => {
    document.documentElement.dir = "ltr";
    document.documentElement.lang = i18n.language;
    const langMap = { ar: "ar" };
    dayjs.locale(langMap[i18n.language] || "en");
  }, [isArabic, i18n.language]);

  // Drive the template's design tokens (radius/density/shadows) via a root
  // data-attribute — see :root[data-ui-template="modern"] in styles/index.css.
  useEffect(() => {
    document.documentElement.setAttribute(
      "data-ui-template",
      uiTemplate || "classic"
    );
  }, [uiTemplate]);

  const theme = useMemo(() => {
    return isArabic
      ? createTheme(themeOptions, arSD)
      : createTheme(themeOptions);
  }, [isArabic]);

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CacheProvider>
  );
};

export default ThemeLocaleProvider;
